import { useState } from "react";
import { Info } from "lucide-react";
import { TooltipProvider, Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/Tooltip";
import { Button } from "@/components/ui/Button";

const MatchScoreLegend = ({ compact = true }) => {
  const [open, setOpen] = useState(false);

  const items = [
    {
      label: "High",
      color: "#87AA92",
      description: "Strong match with the job requirements",
    },
    {
      label: "Normal",
      color: "#eab308",
      description: "Partial match with the job requirements",
    },
    {
      label: "Low",
      color: "#B32929",
      description: "Weak match with the job requirements",
    },
  ];

  return (
    <div className={`flex items-center text-xs`}>
      {!compact && <span className="font-medium text-text-primary">Match Indicator:</span>}

      {/* <span className="text-text-secondary">(</span> */}

      <div className={`flex ${compact ? "gap-2" : "gap-4"}`}>
        {items.map((item) => (
          <div key={item.label} className="flex items-center gap-1">
            <span className="w-2 h-2 rounded-sm" style={{ backgroundColor: item.color }} />
            <span className="text-text-secondary text-[0.68rem]">{item.label}</span>
          </div>
        ))}
      </div>

      {/* <span className="text-text-secondary">)</span> */}

      <TooltipProvider>
        <Tooltip open={open} onOpenChange={setOpen}>
          <TooltipTrigger asChild>
            <Button
              className="p-0 pl-1"
              onClick={(e) => {
                e.stopPropagation();
                setOpen((v) => !v);
              }}
            >
              <Info className="w-4 h-4 text-muted-foreground" />
            </Button>
          </TooltipTrigger>

          <TooltipContent className="w-72 space-y-2 py-3 flex flex-col text-text-primary">
            {items.map((item) => (
              <div key={item.label} className="flex items-start gap-2">
                <span className="mt-1 h-2 w-2 rounded-full" style={{ backgroundColor: item.color }} />
                <div>
                  <p className="font-medium">{item.label}</p>
                  <p className="text-xs text-text-primary/50">{item.description}</p>
                </div>
              </div>
            ))}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default MatchScoreLegend;
